import translateInline from '@/util/translation/translateInline';
angular.module('inspinia').directive('pageTitle', function ($rootScope, $timeout, $translate) {
  return {
    link: function (scope, element) {
      var listener = function (event, toState, toParams, fromState, fromParams) {
        let title = 'コドモン';
        if (toState.data?.pageTitle) {
          const translatedPageTitle = translateInline(toState.data.pageTitle, $translate);
          title = `${translatedPageTitle} | コドモン`;
        }
        $timeout(function () {
          element.text(title);
        });
      };
      $rootScope.$on('$stateChangeStart', listener);
    },
  };
});
